import { cloneConfig, LegacyConfigError, readLegacyProject, createLegacySavePayload } from './legacy-adapter'

export function createPageId () {
  const crypto = typeof window !== 'undefined' && window.crypto
  if (crypto && typeof crypto.randomUUID === 'function') return `pg_${crypto.randomUUID()}`
  if (crypto && typeof crypto.getRandomValues === 'function') {
    return `pg_${Array.from(crypto.getRandomValues(new Uint32Array(4)), n => n.toString(16).padStart(8, '0')).join('')}`
  }
  return `pg_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}_${Math.random().toString(36).slice(2)}`
}

const object = value => value && typeof value === 'object' && !Array.isArray(value)
const fail = (field, message) => { throw new LegacyConfigError(`pageProject.${field}`, message) }

function normalizeProject (project, defaults = {}) {
  if (!object(project)) fail('', '必须是对象，原数据没有被覆盖')
  if (project.version !== 1) fail('version', '暂不支持此多页面版本，请勿覆盖原数据')
  if (!Array.isArray(project.pages) || !project.pages.length) fail('pages', '至少需要一个页面')
  const ids = new Set()
  const pages = project.pages.map((page, i) => {
    if (!object(page)) fail(`pages[${i}]`, '必须是页面对象')
    if (typeof page.id !== 'string' || !page.id.trim() || ids.has(page.id)) fail(`pages[${i}].id`, '页面编号不能为空或重复')
    ids.add(page.id)
    if (typeof page.name !== 'string' || !page.name.trim() || page.name.trim().length > 60) fail(`pages[${i}].name`, '页面名称必须为1到60个字符')
    if (!object(page.config) || !Array.isArray(page.nodes)) fail(`pages[${i}]`, '缺少页面配置或组件数组')
    try {
      const model = readLegacyProject({ name: page.name, metadata: { config: { detail: page.config, component: page.nodes } } }, defaults)
      return { ...cloneConfig(page), config: model.config, nodes: model.nodes }
    } catch (error) { fail(`pages[${i}]`, error.message) }
  })
  if (!ids.has(project.homePageId)) fail('homePageId', '首页不存在，请修复配置后重试')
  return { ...cloneConfig(project), pages }
}

export function createBlankPage (pages, defaults = {}) {
  let number = 1
  while (pages.some(page => page.name === `页面${number}`)) number++
  let id = createPageId()
  while (pages.some(page => page.id === id)) id = createPageId()
  const name = `页面${number}`
  const config = readLegacyProject({ name, metadata: '' }, defaults).config
  return { id, name, config, nodes: [] }
}

export function readPageProject (record, defaults = {}, pageId) {
  const model = readLegacyProject(record, defaults)
  let project
  if (model.metadata.pageProject !== undefined) project = normalizeProject(model.metadata.pageProject, defaults)
  else {
    const page = { id: createPageId(), name: (model.config.name || '页面1').slice(0, 60), config: model.config, nodes: model.nodes }
    project = { version: 1, homePageId: page.id, pages: [page] }
  }
  const activePageId = pageId || project.homePageId
  const active = project.pages.find(page => page.id === activePageId)
  if (!active) fail('activePageId', '目标页面不存在，请回到编辑器重新预览')
  return { ...model, pageProject: project, activePageId, config: active.config, nodes: active.nodes }
}

// 只生成快照，不改变编辑器中的页面对象或选择状态。
export function snapshotPages (project, activePageId, config, nodes) {
  const copy = cloneConfig(project)
  const active = copy.pages.find(page => page.id === activePageId)
  if (!active) fail('activePageId', '当前页面不存在，不能保存')
  active.config = cloneConfig(config)
  active.nodes = cloneConfig(nodes)
  return normalizeProject(copy)
}

export function createPageSavePayload (record, metadata, project, activePageId, config, nodes) {
  const copy = snapshotPages(project, activePageId, config, nodes)
  const home = copy.pages.find(page => page.id === copy.homePageId)
  // 旧单页读取器仍能读到首页；未知 metadata、visual、绑定等字段继续保留。
  return createLegacySavePayload(record, { ...metadata, pageProject: copy }, home.config, home.nodes)
}
